import { ModalWindow } from "../../UI/ModalWindow";
import { Input, Select } from '../../UI/FormElements'

const ROUTE_URL = "/sys_users";
const initialData = { smsflag: "0", emailflag: "0" };

function ModalNotificationsType({ params, handleClose }) {
  console.log('paramsparams', params);

  let urlSubmit, urlGet;
  if (params.isNew) {
    urlSubmit = ROUTE_URL;
    urlGet = ""; //или ROUTE_URL + "/create" если при создании НАДО предварительное обращение к серверу

  }
  else {
    urlGet = ROUTE_URL + "/" + params.id + "?notifications";
    urlSubmit = urlGet;

  }

  return (
    <ModalWindow params={params} handleClose={handleClose} initialData={initialData} urlGet={urlGet} urlSubmit={urlSubmit} >
      <IncidentCardsFields />
    </ModalWindow>
  );
}
// let categoryTypes = [{ id: 1, name: "Отказ" }, { id: 2, name: "Авария" }, { id: 3, name: "Сбой" }, { id: 4, name: "Перерыв по связи" }];

const IncidentCardsFields = ({ dopParams, ...elementProps }) => {
  return (
    <div className="row form-gutter">
      <div className="col-12 rowcols">
        {/* <div className="rowcol">
          <Input label="Владелец" name="owner" {...elementProps} required />
        </div> */}
        <div className="rowcol checkbox flag">
          <Input type="checkbox" className="form-check-input actcheck " label="Оповещать по email" name="emailflag" {...elementProps} onChange={(e) => e.target.checked ? elementProps.data.emailflag = 1 : elementProps.data.emailflag = 0} />
        </div>
        <div className="rowcol checkbox flag">
          <Input type="checkbox" className="form-check-input actcheck " label="Оповещать по sms" name="smsflag" {...elementProps} onChange={(e) => e.target.checked ? elementProps.data.smsflag = 1 : elementProps.data.smsflag = 0} />
        </div>
      </div>
      {/* <div className="col-12">
        <Input label="Адрес" name="address"  {...elementProps} required autoFocus />
      </div> */}
    </div>
  )
}
export default ModalNotificationsType;
